module.exports = __webpack_public_path__ + "static/media/iiitk_logo.c350d799.png";